export { default } from './RemoveUserBlackListPopUp';



// WEBPACK FOOTER //
// ./src/components/UserBlackList/RemoveUserBlackListPopUp/index.js